import { render, staticRenderFns } from "./FinanceCard.vue?vue&type=template&id=32067804"
import script from "./FinanceCard.vue?vue&type=script&lang=js"
export * from "./FinanceCard.vue?vue&type=script&lang=js"
import style0 from "./FinanceCard.vue?vue&type=style&index=0&id=32067804&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_f8be560a05ba39e4779a4b3800f88bf1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports